module.exports = __webpack_public_path__ + "img/python.6efba8a3.png";